<template>
  <div class="page">
    <BookingBack title="Gift Card" :textColor="'#333333'" :isCenter="true" />

    <div class="content">
      <div class="icon">
        <van-icon name="close" size="40" color="#fff" />
      </div>
      <div class="title">Payment canceled</div>
      <div class="desc" v-if="orderNo">Order No: {{ orderNo }}</div>

      <div class="actions">
        <div class="btn primary" @click="retryBuy">Try again</div>
        <div class="btn" @click="goGiftCards">Back</div>
      </div>
    </div>
  </div>
</template>

<script>
import BookingBack from '@/components/Booking/back.vue'

const SS_PAYMENT_HANDLED = 'giftcard_payment_handled'

export default {
  name: 'GiftCardCancel',
  components: { BookingBack },
  data() {
    return {
      cardId: '',
      orderNo: ''
    }
  },
  created() {
    const q = this.$route.query || {}
    this.cardId = q.card_id || ''
    this.orderNo = q.order_no || ''
  },
  methods: {
    retryBuy() {
      if (!this.cardId) {
        this.$router.replace('/giftCard')
        return
      }
      // Clear the payment handled flag so user can retry payment
      try { sessionStorage.removeItem(SS_PAYMENT_HANDLED) } catch (e) {}
      this.$router.replace({ path: '/giftCardBuy', query: { card_id: this.cardId } })
    },
    goGiftCards() {
      // Clear all payment-related markers to prevent navigation issues
      try { sessionStorage.removeItem(SS_PAYMENT_HANDLED) } catch (e) {}
      try { sessionStorage.removeItem('__stripe_skip_fix') } catch (e) {}
      try { sessionStorage.removeItem('__stripe_from_fullPath') } catch (e) {}
      try { sessionStorage.removeItem('__stripe_from_ts') } catch (e) {}
      try { sessionStorage.removeItem('__stripe_fix_pending') } catch (e) {}
      try { sessionStorage.removeItem('__stripe_return_to_fullPath') } catch (e) {}
      try { sessionStorage.removeItem('__stripe_nav_mode') } catch (e) {}
      try { sessionStorage.removeItem('giftcard_order_no') } catch (e) {}
      try { sessionStorage.removeItem('giftcard_order_id') } catch (e) {}
      try { sessionStorage.removeItem('giftcard_card_id') } catch (e) {}
      // Prefer going back to the existing detail page entry (so detail->back returns to list),
      // but fall back to a direct replace if there is no history.
      if (this.cardId) {
        try {
          if (typeof window !== 'undefined' && window.history && window.history.length > 1) {
            this.$router.go(-1)
            return
          }
        } catch (e) {}
        this.$router.replace({ path: '/giftCardDetail', query: { card_id: this.cardId } })
        return
      }
      this.$router.replace('/giftCard')
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  min-height: 100vh;
  background: #fff;
}

.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem 1rem;
}

.icon {
  width: 70px;
  height: 70px;
  background: #d93b3b;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
}

.title {
  font-size: 1.125rem;
  color: #333;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.desc {
  font-size: 0.875rem;
  color: #999;
  margin-bottom: 1.5rem;
}

.actions {
  width: 100%;
  max-width: 360px;
}

.btn {
  width: 100%;
  height: 2.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.5rem;
  background: #f2f2f2;
  color: #333;
  font-size: 0.9375rem;
  font-weight: 600;
  margin-bottom: 0.75rem;
}

.btn.primary {
  background: #1a3a2f;
  color: #fff;
}
</style>

